export default __webpack_public_path__ + "static/media/color-picker.1e30b806.svg";